export default __webpack_public_path__ + "static/media/Javier Sanchez de La-Puente.923656e2.jpg";